<template>
  <div class="userList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入用户id"
        clearable
        v-model="userParam.uid"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input">
      </el-input>
      <el-input
        placeholder="请输入用户名"
        clearable
        v-model="userParam.name"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input">
      </el-input>
      <el-input
        placeholder="请输入手机号码"
        clearable
        v-model="userParam.mobile"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input">
      </el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime">
      </el-date-picker>
      <el-button type="primary" size="small" @click="refreshSearch">
        搜索
      </el-button>
      <el-button type="success" size="small" @click="addUser">
        新增
      </el-button>
    </div>
    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="620">
      <el-table-column
        prop="uid"
        label="用户ID"
        align="center"
        width="100"
        fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="devID"
        class-name="col_layout"
        label="UUID"
        align="center"
        width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.devID || "未知" }}</span>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-refresh"
            @click="refreshDev(scope.row.uid)">
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号码"
        align="center"
        width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="昵称" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userImage"
        label="用户头像"
        align="center"
        width="140"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'80px'"
            :src="imgUrl + scope.row.portrait">
          </img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="summary"
        label="个人简介"
        align="center"
        width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.summary }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="vipLevelLabel"
        label="VIP等级"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="devType"
        label="设备类型"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.devType || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="注册时间"
        align="center"
        width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="loginDays"
        label="登陆天数"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.loginDays || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="lastActive"
        label="最后活跃时间"
        align="center"
        width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.lastActive | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金币余额"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.amount || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="income"
        label="金币收益"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.income || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="rewarded"
        label="打赏金额"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.rewarded || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="inviteCount"
        label="邀请数"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.inviteCount || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isDirect"
        label="是否直推用户"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.isDirect ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="superUser"
        label="是否是大V"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.superUser ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="officialCert"
        label="是否官方认证"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.officialCert ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isMadou"
        label="是否工作室"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.isMadou ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="region" label="城市" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.region || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="videoCnt"
        label="视频数"
        align="center"
        width="70">
        <template slot-scope="scope">
          <span>{{ scope.row.videoCnt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="deleteUser(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 20, 30]"
      :current-page="userParam.pageNumber"
      :page-size="userParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增-->
    <add ref="addUser"></add>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import { changeTime } from "@/utils/global";
import API from "@/api";
import add from "./components/add";
import { sortEscape } from "@/utils/global";
export default {
  data() {
    return {
      dialogFormVisible: false,
      banTableData: [],
      uid: "",
      banTotal: "",
      banLoading: false,
      form: {
        phone: "",
      },
      imgUrl: baseConfig.imgUrl,
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      idList: [],
      // 封禁理由列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      // 用户管理列表请求参数
      userParam: {
        autoFollow: true,
        uid: "",
        pageNumber: 1,
        pageSize: 5,
        name: null,
        mobile: null,
        startTime: "",
        endTime: "",
      },
    };
  },
  components: {
    add,
  },
  created() {
    // this.getUserList(this.userParam);
  },
  methods: {
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.userParam.startTime = changeTime(time[0]);
        this.userParam.endTime = changeTime(time[1]);
      } else {
        this.userParam.startTime = "";
        this.userParam.endTime = "";
      }
      this.refreshSearch();
    },
    // 搜索对应列表
    refreshSearch() {
      this.userParam.pageNumber = 1;
      this.getUserList(this.userParam);
    },
    // 搜索对应列表
    search() {
      this.getUserList(this.userParam);
    },
    // 请求用户列表
    getUserList(obj) {
      this.loading = true;
      API.getUserList(obj)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            let roleObj = {
                snap: "普通用户",
                user: "VIP用户",
              },
              vipObj = {
                0: "非VIP用户",
                1: "铂金卡",
                2: "钻石卡",
                3: "至尊卡",
              };
            this.tableData = res.data.list;
            this.tableData.forEach((item) => {
              item.roleLabel = roleObj[item.role] ? roleObj[item.role] : "-";
              item.vipLevelLabel = vipObj[item.vipLevel]
                ? vipObj[item.vipLevel]
                : "-";
            });
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.userParam.value = sortEscape(column.order);
      this.userParam.key = column.prop;
      this.getUserList(this.userParam);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.userParam.pageSize = size;
      this.userParam.pageNumber = 1;
      this.getUserList(this.userParam);
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.userParam.pageNumber = pageNumber;
      this.getUserList(this.userParam);
    },
    // 添加用户
    addUser() {
      this.$refs.addUser.open();
    },
    // 移除用户
    deleteUser(row) {
      this.$confirm("您确定要移除当前用户？", "移除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uid: row.uid,
            autoFollow: false
          };
          API.editUser(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "移除成功",
                type: "success",
              });
              this.refreshSearch();
            } else {
              this.$message({
                message: "移除失败: "+res.msg ? res.msg : res.tip,
                type: "failed",
              });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss">
.el-message-box {
  .cancel_right {
    float: right;
    margin-left: 10px;
  }
}
</style>
<style scoped lang="scss">
.userList-box {
  .v-number {
    vertical-align: middle;
  }
  .view-details {
    margin-left: 10px;
    color: #e63765;
    font-size: 18px;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #eb5f84;
    }
  }
  /deep/.col_layout {
    /deep/ div {
      display: flex;
      justify-content: center;
      padding-left: 50px;
      button {
        margin-left: auto;
      }
    }
  }
}
</style>
